export default {
  title: "Edit Correction Information",
  issue_actions_updated: "Issue action(s) updated successfully",
}
